import { NavLink } from "react-router-dom";

const DataTable = ({ paymentCategories, handleDelete }) => {

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="text-left" width="20%">Name</th>
                    <th className="text-left">Description</th>
                    <th className="text-left" width="1%"/>
                    <th className="text-left" width="1%"/>
                </tr>
            </thead>
            <tbody>
                {paymentCategories.map(paymentCategory => 
					<tr key={paymentCategory.id}>
						<td>{paymentCategory.name}</td>
						<td>{paymentCategory.description}</td>
						<td className="text-right">
							<NavLink to={`/data/payment-categories/${paymentCategory.id}`} className="btn btn-primary btn-icon">
                                <span className="las la-pen" />
                            </NavLink>
                        </td>
						<td className="text-right">
							<button className="btn btn-danger btn-icon" onClick={() => handleDelete(paymentCategory)}>
                                <span className="las la-trash-alt" />
                            </button>
						</td>
					</tr>
				)}
            </tbody>
        </table>
    );
}
 
export default DataTable;